import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  requestChallengePayload,
  requestGetUserPayload,
  requestVerifyFactorPlayload,
} from '../../../shared/models/model';
import { Router } from '@angular/router';
import { OktaService } from '../../../shared/services/okta.service';
import { Subscription } from 'rxjs';
import { AuthorizationService } from '../../../shared/services/authorization.service';
import config from '../../../../assets/config.json';
@Component({
  selector: 'app-mfachallenge-factor',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './mfachallenge-factor.component.html',
  styleUrl: './mfachallenge-factor.component.scss',
})
export class MFAChallengeFactorComponent implements OnInit {
  userFactorSelection: boolean = false;
  userChallengeFactor: boolean = false;
  IsinvalidOtp: boolean = false;
  phoneButtonText: string = 'Send Code';
  emailButtonText: string = 'Send Code';
  selectedFactorType: number = 0;
  selectedMaskedFactorValue: string = '';
  mfaForm: FormGroup = new FormGroup({});
  userData: any;
  isErroeInSlect: boolean = false;
  selectError: string = '';
  isOtpResent: boolean = false;
  otpResentMessage: string = '';
  codeSentFirstTime: boolean = false;
  MFALoginKeyName: string = config.MFALoginKeyName;
  challengeFactorSubscription: Subscription = new Subscription();
  verifyFactorSubscription: Subscription = new Subscription();
  getUserDetailsSubscription: Subscription = new Subscription();
  constructor(
    private _okta: OktaService,
    private _router: Router,
    private _fb: FormBuilder,
    public _authService: AuthorizationService,
  ) {}
  ngOnInit() {
    this.createForm();
    this.getUserDetails();
  }

  getUserDetails(): void {
    const payload: requestGetUserPayload = {
      requestingSystem: 'FinPro',
      browserName: this._okta.getBrowserName(),
      userName: this._authService.getUserId(),
    };
    this.getUserDetailsSubscription = this._okta.getUser(payload)?.subscribe({
      next: (_data) => {
        if (_data) {
          this.userData = _data;
          this.assignUserFactor();
          if (this.userData?.nextAction === 'Challenge') {
            this.userChallengeFactor = true;
            this.userFactorSelection = false;
            this.ChallengeFactorApi(this.userData?.mfaInfo.activeFactors[0]?.factorType);
          } else if (this.userData?.nextAction === 'Select') {
            this.userFactorSelection = true;
            this.userChallengeFactor = false;
          }
        }
      },
      error: (err) => {
        this.userChallengeFactor = false;
        this.userFactorSelection = false;
        this.selectError = err;
      },
    });
  }

  createForm(): void {
    this.mfaForm = this._fb.group({
      securityCode: [
        '',
        [
          Validators.required,
          Validators.pattern('^[0-9]{5,6}$'), // Matches exactly 5 or 6 digits
          Validators.minLength(5), // Minimum length of 5
          Validators.maxLength(6), // Maximum length of 6
        ],
      ], // assuming 6-digit code
      remind: [false],
    });
  }

  onSubmit(): void {
    if (this.mfaForm.valid) {
      const formValues = this.mfaForm.value;
      this.verifyFactor(formValues.securityCode);
    } else {
      this.IsinvalidOtp = true;
      setTimeout(() => {
        this.IsinvalidOtp = false;
      }, 6000);
      setTimeout(() => {
        const firstInvalidControl = document.querySelector('.is-required.ng-invalid');
        if (firstInvalidControl) {
          (firstInvalidControl as HTMLElement).focus();
        }
      }, 100);
    }
  }

  ChallengeFactorApi(factorType: number) {
    const payload: requestChallengePayload = {
      requestingSystem: 'FinPro',
      factorType: factorType,
    };
    this.challengeFactorSubscription = this._okta.challengeFactorApi(payload)?.subscribe({
      next: (_data) => {
        if (this.codeSentFirstTime) {
          if (_data.success) {
            this.isOtpResent = true;
            this.otpResentMessage = 'Code was resent';
            setTimeout(() => {
              this.isOtpResent = false;
            }, 6000);
          } else {
            this.isOtpResent = true;
            this.otpResentMessage = 'Code resent falied';
            setTimeout(() => {
              this.isOtpResent = false;
            }, 6000);
          }
        }
      },
      error: () => {
        this.isOtpResent = true;
        this.otpResentMessage = 'Code resent failed';
        setTimeout(() => {
          this.isOtpResent = false;
        }, 6000);
      },
    });
  }
  assignUserFactor(): void {
    if (this.userData?.mfaInfo.activeFactors.length === 1) {
      this.selectedMaskedFactorValue = this.userData?.mfaInfo.activeFactors[0]?.maskedFactorValue;
      this.selectedFactorType = this.userData?.mfaInfo.activeFactors[0]?.factorType;
    }
  }

  verifyFactor(securityCode: string): void {
    this.IsinvalidOtp = false;
    const payload: requestVerifyFactorPlayload = {
      requestingSystem: 'FinPro',
      passCode: securityCode,
      factorType: this.selectedFactorType,
      browserName: this._okta.getBrowserName(),
      rememberMe: this.mfaForm.get('remind')?.value,
    };
    this.verifyFactorSubscription = this._okta.verifyFactorApi(payload)?.subscribe({
      next: (_data) => {
        if (_data) {
          if (this.mfaForm.get('remind')?.value === true) {
            this.saveRememberMeToken(_data.a9b7xk_0q, 7); // Save the remember me token for 7 days
          } else {
            this.saveMFAToken(_data.a9b7xk_0q); // Clear the remember me token
          }
          if (this._authService.getUrl()) {
            this._router.navigate([this._authService.getUrl()?.path], {
              queryParams: this._authService.getUrl()?.queryParams,
            });
          } else {
            this._router.navigate(['advisor']);
          }
        }
      },
      error: () => {
        setTimeout(() => {
          const firstInvalidControl = document.querySelector('.is-required.ng-invalid');
          if (firstInvalidControl) {
            (firstInvalidControl as HTMLElement).focus();
          }
        }, 100);
        this.IsinvalidOtp = true; // Ensure this is set immediately
        setTimeout(() => {
          this.IsinvalidOtp = false;
        }, 6000);
      },
    });
  }

  resendCode(): void {
    this.mfaForm.get('securityCode')?.reset();
    this.codeSentFirstTime = true;
    this.ChallengeFactorApi(this.selectedFactorType);
  }

  sendCode(_fact_type: number): void {
    this.selectedFactorType = _fact_type;
    const selectedFactor = this.userData?.mfaInfo.activeFactors.find(
      (element: { factorType: number }) => element.factorType === _fact_type,
    );

    if (selectedFactor) {
      this.selectedMaskedFactorValue = selectedFactor.maskedFactorValue;
    }
    this.userFactorSelection = false;
    this.userChallengeFactor = true;
    this.ChallengeFactorApi(_fact_type);
  }

  changeSecurityMethod(): void {
    this.userFactorSelection = true;
    this.userChallengeFactor = false;
  }

  saveRememberMeToken(token: string, days: number = 7): void {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000); // Set expiration date
    const expires = 'expires=' + date.toUTCString(); // Convert the date to UTC string
    const encodedToken = btoa(token + this.MFALoginKeyName); // Base64 encode the token to ensure it's safely stored
    // Set the cookie with the 'Secure' and 'Path' attributes
    document.cookie = `${this.MFALoginKeyName}=${encodedToken}; ${expires}; path=/; Secure;`;
  }
  saveMFAToken(token: string): void {
    const date = new Date(Date.now() + Number(config.idleAppMfaTimeOut)); // Set expiration date using config.idleAppMfaTimeOut
    const expires = 'expires=' + date.toUTCString(); // Convert the date to UTC string
    const encodedToken = btoa(token); // Base64 encode the token to ensure it's safely stored
    // Set the cookie with the 'Secure' and 'Path' attributes
    document.cookie = `${this.MFALoginKeyName}=${encodedToken}; ${expires}; path=/; Secure;`;
  }
}
